import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router.js'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  document.title = to.name;
  let link = document.querySelector("link[rel*='icon']")
  link.href = to.name.includes('Emisiowo') ? '/static/emisia.ico' : '/static/favicon.ico'
  next();
});

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
